export default function (widget) {
    const m = widget.m;
    const state = widget.state;
    const t = widget.txt;

    const ns = widget.ns + '__stepper';
    const nsbutton = ns + '__button';

    const timelineStepper = {
        controller: function (/*props*/) {
            const ctrl = this;

            // var delayedStepId;
            // var steppingDelay = 750;
            // var stepAndStartDelayedStepping = function (e, delta) {
            //   if (!e.button) {
            //     state.shiftTimelineIndex(delta);
            //     clearInterval( delayedStepId );
            //     delayedStepId = setInterval(function(){
            //         state.shiftTimelineIndex(delta);
            //         state.autoStepStart(delta);
            //         m.redraw();
            //       }, steppingDelay);
            //   }
            //   else {
            //     m.redraw.strategy('none');
            //   }
            // };
            // ctrl.stepForward = function (e) {
            //   stepAndStartDelayedStepping( e, 1 );
            // };
            // ctrl.stepBack = function (e) {
            //   stepAndStartDelayedStepping( e, -1 );
            // };
            // ctrl.stepCancel = function (e) {
            //   clearInterval( delayedStepId );
            //   state.autoStepStop();
            //   e.currentTarget.blur();
            // };

            ctrl.toggleAutoStepping = function (/*e*/) {
                const button = this;
                state.isAutoPlaying ?
                state.autoStepStop() :
                state.autoStepStart();
                button.blur();
            };

            const last = {};
            ctrl.maySkipRendering = function () {
                const maySkip = state.timepoint === last.timepoint && state.isAutoPlaying === last.isAutoPlaying;
                last.timepoint = state.timepoint;
                last.isAutoPlaying = state.isAutoPlaying;
                return maySkip;
            };
        },


        view: function (ctrl/*, props*/) {
            // ctrl.props = props || {};

            if (ctrl.maySkipRendering()) {
                return {subtree: 'retain'};
            }

            // var atEnd = state.isAtTimelineEnd();
            // var atStart = state.isAtTimelineStart();
            const playActionName = state.isAutoPlaying ? 'stop' : 'start';
            const playActionText = t('$stepper--autoplay', playActionName);
            return (
                m('div', {className: ns},
                    // m('button', {
                    //     className: nsbutton + nsbutton+'--next' + (atEnd ? nsbutton+'--disabled' : ''),
                    //     disabled: atEnd,
                    //     onmousedown: ctrl.stepForward,
                    //     onmouseup: ctrl.stepCancel,
                    //     title: t('$stepper--next'),
                    //   },
                    //   t('$stepper--next')
                    // ),
                    // m('button', {
                    //     className: nsbutton + nsbutton+'--prev' + (atStart ? nsbutton+'--disabled' : ''),
                    //     disabled: atStart,
                    //     onmousedown: ctrl.stepBack,
                    //     onmouseup: ctrl.stepCancel,
                    //     title: t('$stepper--prev'),
                    //   },
                    //   t('$stepper--prev')
                    // ),
                    m('button', {
                            className: nsbutton + nsbutton + '--autoplay' + (state.isAutoPlaying ? nsbutton + '--is-autoplaying' : ''),
                            onclick: ctrl.toggleAutoStepping,
                            title: playActionText,
                        },
                        playActionText
                    ),
                    null
                )
            );
        },
    };


    return timelineStepper;
}
